<template>
  <div>
    <span v-if="data.column.field === 'name'">
      <div>
        <b-link :to="`emails/edit/${data.row.id}`">{{ data.row.name }}</b-link>
      </div>
    </span>
    <span v-else-if="data.column.field === 'actions'">
      <div class="d-flex justify-content-between">
        <span>
          {{ data.row.createdAt }}
        </span>
        <b-button
          variant="link"
          class="p-0"
          :to="`emails/edit/${data.row.id}`"
        >
          <GjIcon
            name="Edit"
            class="text-primary"
          />
        </b-button>
      </div>
    </span>
    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    GjIcon,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
    },
  },
}
</script>
